<template>
  <div style="margin: 0 30px">
    <div style="max-height: 450px;overflow-y: auto">
      <el-table
        size="mini"
        v-loading="loading"
        element-loading-text="加载中，请耐心等待。"
        :data="showHandleTable"
        border
        style="width: 100%"
        highlight-current-row
        ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="content"
          label="处理详情"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="handletime"
          label="处理时间"
          min-width="140"
          align="center">
        </el-table-column>
        <el-table-column
          prop="customerservicename"
          label="处理人员"
          min-width="100"
          align="center">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="派单情况"-->
<!--          min-width="140"-->
<!--          align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{getOrderName1(scope.row.is_dispatch)}}-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {queryalarmhandle} from '../../../api/handlealarm'

export default {
  name: 'historyHandle',
  model: {
    prop: 'showHistory',
    event: 'change'
  },
  props: {
    handleHistoryObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      showHandleTable: []
    }
  },
  created () {
    this.getAlarmsHistory()
  },
  methods: {
    getAlarmsHistory () {
      this.loading = true
      let data = {
        aids: [this.handleHistoryObj.alarmRow.id]
      }
      queryalarmhandle(data).then(res => {
        this.showHandleTable = res.data.alarmhandle
        this.loading = false
      }).catch(() => {})
    },
    getOrderName1 (isdispatch) {
      if (isdispatch === 0) {
        return '未处理'
      } else if (isdispatch === 1) {
        return '已接单'
      } else if (isdispatch === 2) {
        return '已拒绝'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/historyHandle.vue